// extracted by mini-css-extract-plugin
module.exports = {"statList":"StatList-module--statList--pDWvf","stat":"StatList-module--stat--3s_s8","value":"StatList-module--value--udQdR","label":"StatList-module--label--2jEaV"};